/** Мок «Системы»: живой воркер, одна упавшая попытка, пуши на двух платформах */

import dayjs from 'dayjs';

import type {JobRun, Telemetry, WorkerStatus} from './types';

const run = (
  jobName: string,
  minsAgo: number,
  status: JobRun['status'],
  detail: string | null,
  attempt = 1,
): JobRun => {
  const started = dayjs().subtract(minsAgo, 'minute');
  return {
    id: `${jobName}-${minsAgo}`,
    jobName,
    status,
    attempt,
    startedAt: started.toISOString(),
    finishedAt: status === 'running' ? null : started.add(840, 'millisecond').toISOString(),
    durationMs: status === 'running' ? null : 840,
    detail,
  };
};

export const MOCK_RUNS: JobRun[] = [
  run('expire_trials', 4, 'ok', 'переведено клиник: 1'),
  run('send_notification', 6, 'ok', 'отправлено: 12'),
  run('send_reminders', 31, 'failed', 'WhatsApp: template_not_approved', 2),
  run('sync_templates', 62, 'ok', 'шаблонов: 4'),
  run('cleanup_job_runs', 240, 'ok', 'удалено записей: 318'),
];

export const MOCK_WORKER: WorkerStatus = {
  alive: true,
  lastHeartbeatAt: dayjs().subtract(40, 'second').toISOString(),
  lastRuns: MOCK_RUNS,
};

export const mockTelemetry = (days: number): Telemetry => ({
  days,
  rows: [
    {platform: 'ios', provider: 'apns', sent: 412, failed: 3, displayed: 380, displayRate: 0.92},
    {
      platform: 'android',
      provider: 'fcm',
      sent: 655,
      failed: 21,
      displayed: 301,
      displayRate: 0.46,
    },
  ],
  totalSent: 1067,
  totalFailed: 24,
  totalDisplayed: 681,
});
